import React from 'react';
import "./App.css";
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Process from './components/Process';
import Packages from './components/Packages';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div
      className="App min-h-screen relative overflow-x-hidden"
      style={{ backgroundColor: '#0b1120' }}
      data-testid="app-root"
    >
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyUs />
        <Process />
        <Packages />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
